<template>
  <v-card
    light
    :color="hasUnresolvedEvent ? '#EF2D3F' : endpoint.color_code"
    class="endpoints"
  >
    <v-card-title>
      <div :style="vcardColor">
        <span class="black--text">
          <v-icon
            v-if="hasUnresolvedEvent"
            large
            style="animation: pulse-red 1s infinite;"
          >warning
          </v-icon>
          <strong> {{ endpoint.label }} </strong></span><br>
        <span class="blue--dark-grey subheading">{{ endpoint.ms_link_number }}</span><br>
      </div>
    </v-card-title>
    <v-card-text>
      <span v-if="endpoint.device !== null">
        <p>{{ endpoint.device.label }}</p>
        <v-layout row>
          <v-flex>
            <v-btn
              v-if="endpoint.device.element_id"
              small
              :href="elementLinkCharts"
              target="_blank"
            >
              <v-icon small>bar_chart</v-icon>&nbsp;Charts
            </v-btn>

            <v-btn
              v-if="endpoint.device.element_id"
              small
              :href="elementLinkReading"
              target="_blank"
            >
              <v-icon small>table_chart</v-icon>&nbsp;Messwerte
            </v-btn>
          </v-flex>

          <v-flex>
            <v-btn small @click="toggleThresholds = !toggleThresholds">
              <v-icon small>visibility</v-icon>&nbsp;Schwellwerte
            </v-btn>
            <v-btn
              v-if="hasReadings"
              small
              @click="toggleReading = !toggleReading"
            >
              <v-icon small>visibility</v-icon>&nbsp;Messwerte ({{ updatedAt }})
            </v-btn>
            <v-btn
              v-if="!hasReadings"
              small
              disabled
            >
              <v-icon small>error_outline</v-icon>&nbsp;Keine Daten ({{ updatedAt }})
            </v-btn>
          </v-flex>
        </v-layout>

        <ul v-if="!toggleReading" class="mb-4 readings">
          <li v-for="(reading, label) in readings" :key="label">
            {{ readingFormatted(label, reading) }}
          </li>
        </ul>

        <p v-if="!toggleThresholds" class="thresholds">
          Schwellwerte / Spannung
          <ul class="mb-4">
            <li class="indicate_warning">
              Obergrenze: {{ endpoint.device.threshold_u_max_warn }} V
            </li>
            <li class="indicate_critical">
              Obergrenze: {{ endpoint.device.threshold_u_max_crit }} V
            </li>
            <li class="indicate_warning">
              Untergrenze: {{ endpoint.device.threshold_u_min_warn }} V
            </li>
            <li class="indicate_critical">
              Untergrenze: {{ endpoint.device.threshold_u_min_crit }} V
            </li>
          </ul>
          Schwellwerte / Strom
          <ul>
            <li class="indicate_warning">
              Obergrenze: {{ endpoint.device.threshold_i_max_warn }} A
            </li>
            <li class="indicate_critical">
              Obergrenze:{{ endpoint.device.threshold_i_max_crit }} A
            </li>
            <li class="indicate_warning">
              Untergrenze: {{ endpoint.device.threshold_i_min_warn }} A
            </li>
            <li class="indicate_critical">
              Untergrenze: {{ endpoint.device.threshold_i_min_warn }} A für 60s.
            </li>
          </ul>
        </p>
      </span>
      <span v-else>
        <p>Kein verbundener Sensor.</p>
      </span>
      <stats :endpoint="endpoint" />
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash';
import Stats from './Stats.vue';

export default {
  name: 'Trafostation',
  components: {
    Stats,
  },
  props: {
    endpoint: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    vcardColor() {
      return this.endpoint.color_code;
    },
    hasUnresolvedEvent() {
      if (this.endpoint.events.length > 0) {
        return _.find(this.endpoint.events, (o) => { return o.resolved === false; });
      }
      return false;
    },
  },
};
</script>

<style scoped>
.endpoints {
  padding: 10px;
  margin: 5px;
  opacity: 0.9;
}
</style>
